import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import ViewAlternatives from '../Resolution/ViewAlternatives';

import styles from './styles.scss';

const ViewAlternativesOrRemove = ({
  isInTrolley = false,
  removeFromTrolley,
  productId,
  conflictMessage,
  position,
  listDefinitions,
}) =>
  isInTrolley && removeFromTrolley ? (
    <div className={styles.removeButton}>
      <Button width="full" onClick={removeFromTrolley} label="Remove from trolley" />
    </div>
  ) : (
    <ViewAlternatives
      conflictMessage={conflictMessage}
      productId={productId}
      position={position}
      listDefinitions={listDefinitions}
    />
  );

ViewAlternativesOrRemove.propTypes = {
  isInTrolley: PropTypes.bool,
  productId: PropTypes.string.isRequired,
  removeFromTrolley: PropTypes.func,
  conflictMessage: PropTypes.string,
  position: PropTypes.number,
  listDefinitions: PropTypes.object,
};

export default memo(ViewAlternativesOrRemove);
